<div class="decode-token">
  <img
    src="../../assets/img/login_logo_v2.svg"
    class="decode-token_logo"
    alt="Behamics"
  />

  <ng-container *ngIf="!hasError">
    <mat-spinner diameter="26"></mat-spinner>
    <p class="decode-token_message">Opening your website audit…</p>
  </ng-container>

  <ng-container *ngIf="hasError">
    <p class="decode-token_title">This link isn’t available</p>
    <p class="decode-token_message">
      {{
        errorMessage ||
          "The share link is invalid or has expired. Please ask for a new one."
      }}
    </p>
  </ng-container>
</div>
